import React, { createContext, useContext, useState, useEffect, useRef } from 'react';
import audioSrc from '../music/backsong.mp3';

const AudioContext = createContext();

export const useAudio = () => {
  const context = useContext(AudioContext);
  if (!context) {
    throw new Error('useAudio must be used within an AudioProvider');
  }
  return context;
};

export const AudioProvider = ({ children }) => {
  const [isPlaying, setIsPlaying] = useState(() => {
    // Load initial state from localStorage
    const savedState = localStorage.getItem('audioPlaying');
    return savedState === 'true';
  });

  const audioRef = useRef(new Audio(audioSrc));

  useEffect(() => {
    // Persist state to localStorage
    localStorage.setItem('audioPlaying', isPlaying.toString());

    if (isPlaying) {
      audioRef.current.volume = 0.5;
      audioRef.current.loop = true;
      audioRef.current.play().catch(error => {
        console.log('Audio play failed:', error);
        setIsPlaying(false);
      });
    } else {
      audioRef.current.pause();
    }
  }, [isPlaying]);

  const toggleAudio = () => {
    setIsPlaying(prev => !prev);
  };

  const value = {
    isPlaying,
    toggleAudio,
    setIsPlaying
  };

  return (
    <AudioContext.Provider value={value}>
      {children}
    </AudioContext.Provider>
  );
};
